import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=451db8c5&"
import script from "./BankDetails.vue?vue&type=script&lang=js&"
export * from "./BankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451db8c5')) {
      api.createRecord('451db8c5', component.options)
    } else {
      api.reload('451db8c5', component.options)
    }
    module.hot.accept("./BankDetails.vue?vue&type=template&id=451db8c5&", function () {
      api.rerender('451db8c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/BankDetails.vue"
export default component.exports